export enum MissionAcceptanceFileType {
  contractLdm = 'contract_ldm',
  identityPiece = 'identity_piece',
  addressProof = 'address_proof',
  companyRegistrationProof = 'company_registration_proof',
  statesConstitativeDocument = 'states_constitative_document',
  rbe = 'rbe',
  other = 'other'
}
